
import Component from "vue-class-component";
import Vue from "vue";
import InventoryModule  from "@/store/modules/barcodeSystem/inventory";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { SaveCubesModel } from "@/models/ui/saveCubes";
import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
import { ModelCubesResource } from "@/models/api/barcodeSystem/inventory/cubes";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
    Select
  }
})
export default class ModelCubes extends Vue {
  companyIdFilter: number | null = null
  manufacturerCodeFilter: string = null;
  modelNumberFilter: string = null;
  nullCubesOnly: boolean = true;
  loading: boolean = false;
  records: ModelCubesResource[] = null;
  editModel: SaveCubesModel = null;

  get companyIds() {
    if(this.companyIdFilter)
      return [this.companyIdFilter];
    return null;
  }

  async created() {
  }

  async loadData() {
    this.loading = true;
    try {
      this.records = await inventoryModuleState.getModelCubes({
        companyId: this.companyIdFilter,
        manufacturerCode: this.manufacturerCodeFilter,
        modelNumber: this.modelNumberFilter,
        nullCubesOnly: this.nullCubesOnly
      });
    } catch (ex) {
      notifications.error("Search Failed", "Failed to load records", ex);
    }
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  goBack() {
    this.$router.back();
  }

  async filter() {
    await this.loadData();
  }

  editRecord(record: ModelCubesResource = null) {
    const model = new SaveCubesModel();

    if (record) {
      model.manufacturerCode = record.manufacturerCode;
      model.modelNumber = record.modelNumber;
      model.cubes = record.cubes;
    }

    this.editModel = model;
    this.editModel.visible = true;
  }

  closeEditModal() {
    this.editModel.visible = false;
    this.editModel = null;
  }

  async saveRecord() {
    try {
      this.editModel.saving = true;
      await inventoryModuleState.saveModelCubes(this.editModel.toSaveCubesRequest());
      await this.loadData();
      this.editModel.visible = false;
      this.editModel = null;
      notifications.success("Save Success", "Record successfully saved");
    } catch (ex) {
      this.editModel.saving = false;
      notifications.error("Save Failed", "Failed to save record", ex);
    }
  }

  get canFilter() {
    return this.manufacturerCodeFilter || this.modelNumberFilter || (this.companyIdFilter && this.nullCubesOnly);
  }
}
